<template>
  <div class="grid-table-row position-relative overflow-hidden"
       :class="{'error' : isError}"
       @click.prevent.stop="downloadPdfFile"
  >
    <div class="item__title"><span class="font-condensed">{{ item.title }}</span></div>
    <div class="item__description"><span class="font-condensed">{{ item.description }}</span></div>
    <div class="item__category"><span>{{ item.category }}</span></div>
    <div class="item__language">
      <span>{{ item.locale | translate(labels, 'shared_LanguagesISO') }}</span>
    </div>
    <div class="item__download">
      <b-link class="float-right" :class="{'text-gray' : isError}" :disabled="isError">
        <b-icon icon="download" />
      </b-link>
    </div>

    <b-tooltip :variant="isError ? 'danger' : 'light'"
               noninteractive
               :target="() => $el"
               :title="isError ? translatedLabel('downloadError', 'servicelibrary_ServiceLibraryComponent') : translatedLabel('downloadDetails', 'shared_CommonFunctional')"
    />
  </div>
</template>

<script>
import langs from 'langs'
import {dpmmService} from '@/services'

export default {
  conceptName: ['shared_CommonErrors', 'shared_CommonFunctional', 'servicelibrary_ServiceLibraryComponent', 'shared_LanguagesISO'],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      langs: langs,
      isError: false
    }
  },
  methods: {
    downloadPdfFile() {
      dpmmService.fetchDocumentDownloadLink(this.item.document_id).then(r => {
        const link = document.createElement('a')
        link.href = r
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
      }).catch(() =>
        this.isError = true
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/colors';

.box {
  transition: background-color .15s ease-in-out;
  cursor: pointer;

  &.error {
    cursor: not-allowed;
  }

  &:hover:not(.error) {
    background-color: $gray-300 !important;
  }
}
</style>
